import React, { useEffect, useState } from 'react';
import './EmailConfirmation.css';

const EmailConfirmation = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const statusParam = urlParams.get('status');
    const message = urlParams.get('message');

    if (statusParam === 'success') {
      setStatus('success');
    } else if (statusParam === 'error') {
      setStatus('error');
      setErrorMessage(message || 'There was an issue confirming your email address.');
    } else {
      // No status parameter - this shouldn't happen in normal flow
      // But we'll show an error to be safe
      setStatus('error');
      setErrorMessage('Invalid confirmation link.');
    }
  }, []);

  const handleReturnHome = () => {
    window.location.href = '/';
  };

  if (status === 'loading') {
    return (
      <div className="email-confirmation">
        <div className="confirmation-container">
          <div className="loading-spinner"></div>
          <h2>Confirming your email...</h2>
          <p>Please wait while we verify your email address.</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="email-confirmation">
        <div className="confirmation-container error">
          <div className="error-icon">✗</div>
          <h2>Email Confirmation Failed</h2>
          <p>{errorMessage}</p>
          <button className="return-home-btn" onClick={handleReturnHome}>
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="email-confirmation">
      <div className="confirmation-container success">
        <div className="success-icon">✓</div>
        <h2>Email Confirmed Successfully!</h2>
        <p>Thank you for confirming your email address. You're all set to get stronger and healthier with SlimBuddy.</p>
        <button className="return-home-btn" onClick={handleReturnHome}>
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default EmailConfirmation;